module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 483
// module chunks = 0